import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class AmparosService{
    
    constructor(){}

    async consultarTasa(){
        let url=`${environment.backendUrl}/api/tasa`;
        return await (await fetch(url, {method: 'GET'})).json();
    }

    async consultarDeducible(codigoRamo: number) {
        let url=new URL(`${environment.backendUrl}/api/deducible`);
        let parameters={
            cod_ramo: codigoRamo==null?0:codigoRamo
        };
        Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));

        return await (await fetch(url.toString(), {method: 'GET'})).json();
    }
}